var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<div class=\"pages-remote-background\">\n<div class=\"page-remote-locale-chooser\">\n<locale-chooser-small></locale-chooser-small>\n</div>\n<div class=\"pages-remote-background-band\">\n<div class=\"logo-black\"></div>\n</div>\n<div class=\"pages-remote-content\">\n<div class=\"pages-remote-content-headings\">\n<h3>Oops!</h3>\n<p ng-bind-html=\"'STATIC_PAGES.INVALID_LINK.ALREADY_USED' | translate | html\"></p>\n</div>\n</div>\n</div>\n";
var id1="invalid_link.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/client/templates/invalid_link.html
// module id = 434
// module chunks = 0